import React, { useMemo, useState } from 'react';
import ModalImageSlider from 'global/ImageSlider/Modal';
import Item from './Item';
import { IImageItem } from '../types';

interface ImageListProps {
  images?: IImageItem[];
  onResetImage?: (val: any) => any;
}

function ImageList({ images, onResetImage }: ImageListProps) {
  const [isModalVisible, setVisibilityModal] = useState<boolean>(false);
  const [active, setActive] = useState<number>(0);

  const transformedImages = useMemo(() => images.map((item) => item.imagePreviewUrl), [images]);

  if (images.length === 0) {
    return <div />;
  }

  const onClickImage = (i) => {
    setActive(i);
    setVisibilityModal(!isModalVisible);
  };

  const renderImageList = () => images.map((image: any, i) => (
    <Item
      onClick={() => onClickImage(i)}
      image={image.imagePreviewUrl}
      dimensions={image.dimensions}
      onDelete={() => onResetImage(i)}
    />
  ));

  return (
    <>
      {renderImageList()}
      <ModalImageSlider
        images={transformedImages}
        visible={isModalVisible}
        onClose={() => setVisibilityModal(false)}
        active={active}
        setActive={setActive}
      />
    </>
  );
}

export default React.memo(ImageList);
